import React, { Component } from "react";
import ReactMarkdown from "react-markdown/with-html";
import moment from "moment";
import "./PostDetail.scss";

class PostDetail extends Component {
  render() {
    const { title, createTimestamp, hasHtml, content } = this.props.post;
    const dateInMMDD = moment(createTimestamp).format("MM/DD");
    const replaceCapitalALink = content =>
      content
        .split("<A")
        .join("<a")
        .split("/A>")
        .join("/a>")
        .trim();

    return (
      <div className={"post-detail"}>
        <div className={"mobile-header"}>
          <div className={"mobile-title"}>{title}</div>
          <div className={"mobile-datetime"}>{dateInMMDD}</div>
        </div>
        <ReactMarkdown source={replaceCapitalALink(content)} escapeHtml={!hasHtml} />
      </div>
    );
  }
}

export default PostDetail;
